import * as types from '../services/LoginActionType';

function authReducer(state = {}, action) {
    switch (action.type) {
        case types.LOGIN_REQUEST:
            return { 
                ...state, 
                isAuthLoading: true, 
                loginError: null
            };
        case types.LOGIN_SUCCESS:
            return { ...state, isAuthLoading: false, userData: action.payload, loginError: null };
        case types.LOGIN_FAILURE:
            return { ...state, isAuthLoading: false, loginError: action.payload };

        case types.LOGOUT_REQUEST:
            return { 
                ...state, 
                isAuthLoading: true, 
                logoutError: null
            };
        case types.LOGOUT_SUCCESS:
            return { ...state, isAuthLoading: false, userData: null, logoutReason: action.payload?.reason || null, logoutError: null };
        case types.LOGOUT_FAILURE:
            return { ...state, isAuthLoading: false, logoutError: action.payload };

        case types.RESET_PASSWORD_REQUEST:
            return { ...state, isResetPasswordLoading: true, resetPasswordError: null, resetPasswordSuccess: false };
        case types.RESET_PASSWORD_SUCCESS:
            return { ...state, isResetPasswordLoading: false, resetPasswordSuccess: true };
        case types.RESET_PASSWORD_FAILURE:
            return { ...state, isResetPasswordLoading: false, resetPasswordError: action.payload };

        case types.FORGET_PASSWORD_REQUEST:
            return { ...state, isForgetPasswordLoading: true, forgetPasswordError: null, forgetPasswordSuccess: false };
        case types.FORGET_PASSWORD_SUCCESS:
            return { ...state, isForgetPasswordLoading: false, forgetPasswordSuccess: true, forgetPasswordResponse: action.payload };
        case types.FORGET_PASSWORD_FAILURE:
            return { ...state, isForgetPasswordLoading: false, forgetPasswordError: action.payload, forgetPasswordSuccess: false };

        case types.FORGET_PASSWORD_RESET_REQUEST:
            return { ...state, isForgetPasswordResetLoading: true, forgetPasswordResetError: null, forgetPasswordResetSuccess: false };
        case types.FORGET_PASSWORD_RESET_SUCCESS:
            return { ...state, isForgetPasswordResetLoading: false, forgetPasswordResetSuccess: true, forgetPasswordResetResponse: action.payload };
        case types.FORGET_PASSWORD_RESET_FAILURE:
            return { ...state, isForgetPasswordResetLoading: false, forgetPasswordResetError: action.payload, forgetPasswordResetSuccess: false };

        case types.VERIFY_MFA_REQUEST:
            return { ...state, isMfaVerifying: true, mfaVerifyError: null };
        case types.VERIFY_MFA_SUCCESS:
            return { ...state, isMfaVerifying: false, mfaVerifyData: action.payload, mfaVerifyError: null };
        case types.VERIFY_MFA_FAILURE:
            return { ...state, isMfaVerifying: false, mfaVerifyError: action.payload };

        // Single action to clear all transient alert states
        case types.CLEAR_AUTH_ALERTS:
            return {
                ...state,
                resetPasswordSuccess: false,
                resetPasswordError: null,
                forgetPasswordSuccess: false,
                forgetPasswordError: null,
                forgetPasswordResponse: null,
                forgetPasswordResetSuccess: false,
                forgetPasswordResetError: null,
                forgetPasswordResetResponse: null,
                mfaVerifyData: null,
                mfaVerifyError: null,
                logoutReason: null,
                logoutError: null
            };

        default:
            return state;
    }
}
export default authReducer;